/* eslint-disable no-shadow */
enum EnumChartType {
  BubbleTree = 'bubbleTree',
  Radar = 'radar',
  Radar_v2 = 'radar_v2',
  ki = 'ki',
}

export default EnumChartType;
